export default __webpack_public_path__ + "static/media/banner-image-square-2.6e04366f.jpg";